var map = {
	"./decidim/avatar-multiuser.png": 85880,
	"./decidim/brands/google.svg": 60359,
	"./decidim/cc-badge.png": 84338,
	"./decidim/decidim-logo.svg": 56698,
	"./decidim/default-avatar.svg": 25990,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 57722,
	"./decidim/icons.svg": 82582,
	"./decidim/pattern.png": 50950,
	"./decidim/placeholder-card-g.svg": 66987,
	"./decidim/placeholder-card-l.svg": 18016,
	"./decidim/placeholder.jpg": 22151,
	"./decidim/remixicon.symbol.svg": 38911,
	"./decidim/vendor/leaflet/layers-2x.png": 78786,
	"./decidim/vendor/leaflet/layers.png": 26089,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 21712,
	"./decidim/vendor/leaflet/marker-icon.png": 83599,
	"./decidim/vendor/leaflet/marker-shadow.png": 67516,
	"./decidim/vendor/social-share-button/douban.svg": 22158,
	"./decidim/vendor/social-share-button/email.svg": 19723,
	"./decidim/vendor/social-share-button/facebook.svg": 67629,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 79095,
	"./decidim/vendor/social-share-button/hacker_news.svg": 99983,
	"./decidim/vendor/social-share-button/linkedin.svg": 37779,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 188,
	"./decidim/vendor/social-share-button/pinterest.svg": 46845,
	"./decidim/vendor/social-share-button/reddit.svg": 53581,
	"./decidim/vendor/social-share-button/telegram.svg": 87732,
	"./decidim/vendor/social-share-button/tumblr.svg": 28891,
	"./decidim/vendor/social-share-button/twitter.svg": 35530,
	"./decidim/vendor/social-share-button/vkontakte.svg": 73684,
	"./decidim/vendor/social-share-button/wechat.svg": 4719,
	"./decidim/vendor/social-share-button/whatsapp.svg": 64527,
	"./decidim/vendor/social-share-button/x.svg": 74859,
	"./decidim/vendor/social-share-button/xing.svg": 71229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8519;